// Product setting: retain the existing four-property selection experience.
// Older saved sets of up to twelve remain readable in their stored order.
export const comparisonCapacity = 4;
export const legacyComparisonCapacity = 12;
export const favoriteTypes = ['listing', 'project', 'service_provider', 'investment'];
export const collectionPageSize = 24;
export const collectionId = value => typeof value === 'string' && /^[A-Za-z0-9_-]{1,128}$/.test(value);
